import React, { FC, useEffect, useRef } from 'react';
import { RocheUIQuote, RocheUIQuoteLayout, RocheUIQuoteSize } from '@repo/roche-ui';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { blokToComponent } from '../../helpers/blok-to-component';

type RocheQuoteProps = BlokToComponentProps<{
  quote: string;
  size: string;
  layout: string;
  is_equal_ratio: boolean;
  slotted_subline: any[];
  slotted_image: any[];
  slotted_link: any[];
}>;

export const RocheQuote: FC<RocheQuoteProps> = ({ blok, slot, getComponent }) => {
  const elementRef = useRef<HTMLDivElement>(null);

  // used until roche image is refactored: reverts margins
  useEffect(() => {
    const rocheImage = elementRef.current?.querySelector('roche-image') as unknown as HTMLElement;
    if (rocheImage) {
      rocheImage.style.margin = '0px';
    }
  }, []);

  const slottedSubline = blok.slotted_subline?.map((subline) =>
    blokToComponent({ getComponent, blok: subline }, 'quote-subline'),
  );
  const slottedImage = blok.slotted_image?.map((image) =>
    blokToComponent({ getComponent, blok: image }, 'quote-image'),
  );
  const slottedLink = blok.slotted_link?.map((link) => blokToComponent({ getComponent, blok: link }, 'quote-link'));
  return (
    <div ref={elementRef} slot={slot}>
      <RocheUIQuote
        quote={blok.quote}
        size={blok.size as RocheUIQuoteSize}
        layout={blok.layout as RocheUIQuoteLayout}
        isEqualRatio={blok.is_equal_ratio}
        sublines={slottedSubline}
        image={slottedImage}
        link={slottedLink}
      />
    </div>
  );
};
